import { Box, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { CustomButton } from "../ReusableComponents/CustomButton";
import theme from "../../theme";

export function ToolSelectCard({
  title,
  description,
  icon: Icon,
  accentColor,
  onSelect,
}) {
  return (
    <Box
      onClick={onSelect}
      sx={{
        cursor: "pointer",
        p: 4,
        borderRadius: theme.borderRadius.xxl,
        border: `2px solid ${accentColor}`,
        backgroundColor: "primary.main",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        transition: "all 0.3s ease",
        "&:hover": { transform: "translateY(-4px)" },
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: theme.borderRadius.large,
          backgroundColor: `${accentColor}20`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {Icon && <Icon sx={{ color: accentColor, fontSize: 32 }} />}
      </Box>
      <Typography variant="subtitle1" sx={{ color: "primary.white" }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: "primary.white", flexGrow: 1 }}>
        {description}
      </Typography>
      <CustomButton
        text="Go to Tool"
        onClick={(e) => {
          e.stopPropagation(); // Prevent the parent Box's onClick from firing
          onSelect();
        }}
        fullWidth
        endIcon={<NavigateNextIcon />}
        backgroundColor={accentColor}
        color="primary.main"
      />
    </Box>
  );
}
